import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: 'https://graph.facebook.com/v14.0',
    timeout: 30000
  })

const facebookApi = {
  getAttachments: (messageId) => {
    return instance().get(`/${messageId}/attachments`, {
      params: {
        access_token: store.state.selectedBot.page_access_token
      }
    })
  },
  getInstagramDetail: (request) => {
    const { params } = request
    // fields
    // access_token
    return instance().get(`/me`, {
      params: {
        fields: 'id,name,instagram_business_account.fields(id,name,username,profile_picture_url)',
        ...params
      }
    })
  }
}
export default facebookApi



// WEBPACK FOOTER //
// ./src/api/facebook.js